import React from 'react';
import { Clock } from 'lucide-react';

interface AdminHoursTabProps {
  location: any;
}

const DAYS_LIST = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;
const DAY_LABELS: Record<string, string> = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

const AdminHoursTab: React.FC<AdminHoursTabProps> = ({ location }) => {
  const hours = location?.operatingHours;

  if (!hours || Object.keys(hours).length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200/60 p-5">
        <div className="text-center py-8 text-stone-400">
          <Clock size={32} className="mx-auto mb-2 opacity-50" />
          <p className="text-sm">No operating hours set</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200/60 p-5">
      <h3 className="text-sm font-semibold text-stone-800 mb-4 flex items-center gap-2">
        <Clock size={16} className="text-stone-500" />
        Operating Hours
      </h3>
      <div className="space-y-1">
        {DAYS_LIST.map(day => {
          const h = hours[day];
          const closed = !h || h.closed;
          return (
            <div
              key={day}
              className={`flex items-center justify-between px-4 py-3 rounded-lg ${
                closed ? 'bg-stone-50' : 'bg-emerald-50/50'
              }`}
            >
              <span className={`text-sm font-medium ${closed ? 'text-stone-400' : 'text-stone-700'}`}>
                {DAY_LABELS[day]}
              </span>
              <span className={`text-sm ${closed ? 'text-stone-400' : 'text-emerald-700 font-medium'}`}>
                {closed ? 'Closed' : `${h.open} - ${h.close}`}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminHoursTab;
